import { render, staticRenderFns } from "./AttachmentsGallery.vue?vue&type=template&id=40ac0f22&scoped=true"
import script from "./AttachmentsGallery.vue?vue&type=script&lang=ts"
export * from "./AttachmentsGallery.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentsGallery.vue?vue&type=style&index=0&id=40ac0f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac0f22",
  null
  
)

export default component.exports